<template>
  <div v-if='$store.state.auth.profile'>
    <v-navigation-drawer clipped v-model='$store.state.nav.showDrawer' app :class='navdrawerColor'>
      <v-container class='mt-4'>
        <span class='font-weight-light grey--text text--darken-3'>
          {{ $store.state.auth.profile.name_display }}
        </span>
        <!--
        <span class='font-weight-light grey--text overline'>
          {{ $store.state.auth.profile.group_display }}
        </span>
        -->
      </v-container>
      <v-list nav dense>
        <v-list-item color='info' :to="{ name: 'Dashboard' }" @click='openDashboard'>
          <v-list-item-icon>
            <v-icon>mdi-gauge</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- App Menu -->
        <template v-if='$vuetify.breakpoint.mdAndDown'>
          <v-list-group prepend-icon='mdi-apps'>
            <template v-slot:activator>
              <v-list-item-title>Modules</v-list-item-title>
            </template>
          <wc-app-menu></wc-app-menu>
          </v-list-group>
        </template>
        <template v-else>
          <v-menu content-class='overflow-y-auto' max-height='95%' offset-x open-on-hover transition="slide-x-transition" :close-delay='300' :open-delay='200'>
            <template v-slot:activator='{ on }'>
              <v-list-item color='info' v-on='on'>
                <v-list-item-icon>
                  <v-icon>mdi-apps</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Modules</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon color='info' small>mdi-chevron-right-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <wc-app-menu></wc-app-menu>
          </v-menu>
        </template>

      </v-list>

      <!-- Main Menu -->
      <v-divider v-if='mainMenuTitle' class='my-3'></v-divider>
      <v-subheader class='overline font-weight-light' v-if='mainMenuTitle'>{{ mainMenuTitle }}</v-subheader>
      <v-list nav dense v-if='mainMenu.length'>
        <template v-for='(m, index) in mainMenu'>
          <v-list-item :key='index' color='info' :to="m.route" exact v-if='!m.subRoutesMenu'>
            <v-list-item-icon>
              <v-icon :color='m.color'>{{ m.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ m.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-menu :key='index' v-if='m.subRoutesMenu' offset-x open-on-hover transition="slide-x-transition" :close-delay='300' :open-delay='200'>
            <template v-slot:activator='{ on }'>
              <v-list-item color='info' v-on='on'>
                <v-list-item-icon>
                  <v-icon :color='m.color'>{{ m.icon }} </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ m.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                <v-icon color='info' small>mdi-chevron-right-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-list nav dense>
              <v-subheader :class='headerClass'>{{ m.title }} menu</v-subheader>
              <v-list-item-group color='primary'>
                <v-list-item v-for='(s, sIndex) in m.subRoutesMenu' :key='sIndex' :to="s.route">
                  <v-list-item-icon>
                    <v-icon v-text='s.icon' :color='s.color'></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text='s.title'></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>
      </v-list>

      <!-- Subnav Menu -->
      <v-subheader class='overline font-weight-light mt-5' v-if='subnavTitle'>{{ subnavTitle }}</v-subheader>
      <v-list nav dense v-if='subnav.length'>
        <template v-for='(m, index) in subnav'>
          <v-list-item :color='m.route ? "info" : "grey"' :to="m.route" exact v-if='!m.subRoutesMenu' :key='index' :disabled='!m.route'>
            <v-list-item-icon>
              <v-icon>{{ m.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ m.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-menu :key='index' v-if='m.subRoutesMenu' offset-x open-on-hover transition="slide-x-transition" :close-delay='300' :open-delay='200'>
            <template v-slot:activator='{ on }'>
              <v-list-item color='info' v-on='on'>
                <v-list-item-icon>
                  <v-icon :color='m.color'>{{ m.icon }} </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ m.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                <v-icon color='info' small>mdi-chevron-right-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-list nav dense>
              <v-subheader :class='headerClass'>{{ m.title }} menu</v-subheader>
              <v-list-item-group color='primary'>
                <v-list-item v-for='(s, sIndex) in m.subRoutesMenu' :key='sIndex' :to="s.route">
                  <v-list-item-icon>
                    <v-icon v-text='s.icon' :color='s.color'></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text='s.title'></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>
      </v-list>

      <!-- ExtraNav Menu -->
      <v-subheader class='overline font-weight-light mt-5' v-if='extraNavTitle'>{{ extraNavTitle }}</v-subheader>
      <v-list nav dense v-if='extraNav.length'>
        <template v-for='(m, index) in extraNav'>
          <v-list-item :color='m.route ? "info" : "grey"' :to="m.route" exact v-if='!m.subRoutesMenu' :key='index' :disabled='!m.route'>
            <v-list-item-icon>
              <v-icon>{{ m.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ m.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-menu :key='index' v-if='m.subRoutesMenu' offset-x open-on-hover transition="slide-x-transition" :close-delay='300' :open-delay='200'>
            <template v-slot:activator='{ on }'>
              <v-list-item color='info' v-on='on'>
                <v-list-item-icon>
                  <v-icon :color='m.color'>{{ m.icon }} </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ m.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                <v-icon color='info' small>mdi-chevron-right-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-list nav dense>
              <v-subheader :class='headerClass'>{{ m.title }} menu</v-subheader>
              <v-list-item-group color='primary'>
                <v-list-item v-for='(s, sIndex) in m.subRoutesMenu' :key='sIndex' :to="s.route">
                  <v-list-item-icon>
                    <v-icon v-text='s.icon' :color='s.color'></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text='s.title'></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </template>
      </v-list>
      <br v-if='$vuetify.breakpoint.mdAndDown'> <!-- last menu item can be impossible to press under iPhone browser footer -->
    </v-navigation-drawer>

    <!-- <v-toolbar color='primary' dark app dense flat fixed clipped-left> -->

    <v-app-bar :color='navColor' flat dark short fixed clipped-left clipped-right app>
      <v-app-bar-nav-icon @click.stop="$store.dispatch('toggleDrawer')"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <span style="font-weight: 300">CPM  <span class='grey--text text--lighten-1'>2.0</span></span>
        <v-btn color='warning' depressed small rounded v-if='isDev' @click='showAPIURL' class='ml-2'>
          Development
        </v-btn>
        <v-btn color='red' depressed small rounded v-if='isStaging' @click='showAPIURL' class='ml-2'>
          <v-icon color='white' small left>mdi-alert</v-icon> Staging
        </v-btn>
        <v-btn color='yellow' depressed small rounded v-if='isLocal' @click='showAPIURL' class='ml-2 black--text'>
          <v-icon color='black' small left>mdi-alert</v-icon> Local
        </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <wc-system-search></wc-system-search> -->
<!--       <v-tooltip bottom>
        <template v-slot:activator='{ on }'>
          <v-btn
            icon
            href
            @click='openBugTracker'
            to='https://westcapsolutions.atlassian.net/servicedesk/customer/portal/'
            v-on='on'
          >
            <v-icon>mdi-bug</v-icon>  
          </v-btn>
        </template>
        <span>
          Bug/Feature tracker
        </span>
      </v-tooltip>
 -->

      <!-- Refresh Required (new update) -->
      <v-btn color='error' v-if='newVersionAlert' elevation='10' rounded :class="$vuetify.breakpoint.smAndDown ? '' : 'mr-2'" @click='showNewVersionDialog = true'>
        <v-icon :left='!$vuetify.breakpoint.smAndDown'>mdi-refresh</v-icon>
        <span v-if='!$vuetify.breakpoint.smAndDown'>Refresh required</span>
      </v-btn>

      <v-tooltip bottom v-if='showInquiryButtons'>
        <template v-slot:activator='{ on }'>
          <v-btn
            icon
            v-on='on'
            @click='showNewInquiryDialog = true'
          >
            <v-icon>{{ $store.state.icons.modules.inquiries.icon }}</v-icon>
          </v-btn>
        </template>
        <span class='caption'>Start New Inquiry</span>
      </v-tooltip>

      <new-inquiry @cancel='showNewInquiryDialog = false' :showDialog='showNewInquiryDialog'></new-inquiry>


     <!-- Bounced emails alert menu -->
     <!-- MJ - This will display for non-mobile users only - not sure best way to restrict to certain users - non-mobile query? perms? -->

      <v-btn v-if='emailErrorArray.length && !$vuetify.breakpoint.smAndDown' icon  @click='showErrorDialog = true'>
        {{ emailErrorArray.length }}
        <v-icon>mdi-email-alert-outline</v-icon>
      </v-btn>
    
      <wc-dialog
        :showDialog='showNewVersionDialog'
        title='Update Available!'
        icon='mdi-refresh'
        @cancel='showNewVersionDialog = false'
        @save='$router.go(0)'
        width='400'
        saveText='Refresh Now'
      >
        There is an update available for the CPM. Please click "Refresh Now" to load the update.<br>
        <br>
        If you are in the middle of something, click "Cancel" to close this dialog and finish what you are doing.<br>
        <br> 
        <strong>It is <u>critical</u> that you refresh as soon as possible to avoid problems!</strong><br>
        <br>
        Click the "Refresh Required" button in the menu bar when you're ready to refresh.
      </wc-dialog>

      <wc-dialog
        :showDialog='showErrorDialog'
        title='Bounced Email List'
        icon='mdi-email-alert-outline'
        @cancel='showErrorDialog = false'
        hideSave
        width='600'
        cancelText='close'
      >
        <template v-slot:toolbarButtons>
          <v-btn small color='primary' elevation='0' @click='showErrorDialog = false'>Close</v-btn>
        </template>
        <v-list>
          <wc-bounced-email-menu-item
            v-for='(email, index) in emailErrorArray' :key='index'
            :email='email'
            @clearAlert='clearAlert'
          ></wc-bounced-email-menu-item>
        </v-list>
      </wc-dialog>
    
      <v-snackbar
        top
        right
        :color='snackbarColor'
        :timeout='snackbarTimeout'
        v-model='snackbar'
      >
        <span v-html='snackbarText'></span>
        <template v-slot:action="{ attrs }">
          <v-btn
            v-if='scheduleError'
            color="white"
            text
            v-bind="attrs"
            @click="closeScheduleError"
          >
            Okay
          </v-btn>
        </template>
      </v-snackbar>


      <!-- User Menu -->
      <v-menu offset-y transition='scroll-y-transition' left :close-delay='300'>
        <template v-slot:activator='{ on }'>
          <v-btn icon v-on='on'>
            <v-icon>mdi-account-circle</v-icon>
            <v-badge
              v-if='tasksArray.length'
              :color='taskBadge.color'
              :content='taskBadge.content'
              :offset-x='8'
            ></v-badge>
          </v-btn>
        </template>
        <wc-user-menu :taskBadge='taskBadge' :tasksArray='tasksArray'></wc-user-menu>
      </v-menu>
    </v-app-bar>
  </div>

</template>

<script>
/*
--------------------------
MAIN NAV
--------------------------
To use this component, the `@store` needs to be availalbe, and must have the `getProfile` getter available.
Since this component is nested within the Capital submodule, this should already be available.

The component needs two props:
- app <-- this is the name of the app that is using the navigation. It will be displayed along the top
- standardMenu <-- this menu is available to all users, regardless of their staff_group level
- userMenu <- this object is all the menu options that the specific user has access to, based on their staff_group level

*/
import _ from 'lodash';
import axios from 'axios';
import WCAppMenu from '@/components/nav/WCAppMenu';
import WCUserMenu from '@/components/nav/WCUserMenu';
import WCBouncedEmailMenu from '@/components/nav/WCBouncedEmailMenu';
import NewInquiry from '@/modules/inquiries/components/NewInquiry';
import permsService from '@/services/perms';
import VueNativeSock from 'vue-native-websocket';
import Vue from 'vue';
import store from '@/store';  
import {debug} from '../../../settings';
import {local} from '../../../settings';
import {getSocketAddress} from '../../../socket_settings';

export default {
  name: 'main-nav',
  props: {
    app: {
      type: String,
      required: true
    }
  },
  data: () => ({
    navdrawerColor: 'grey lighten-5',
    headerClass: 'overline font-weight-light',
    emailErrorTotal: 0,
    taskCount: 0,
    showErrorDialog: false,
    showNewVersionDialog: false,
    showNewInquiryDialog: false,
    snackbar: false,
    snackbarText: 'error',
    snackbarColor: 'error',
    snackbarTimeout: 6000,
    search: ''
  }),
  watch: {
    emailErrorArray() {
      if (this.emailErrorArray.length > this.emailErrorTotal && !this.$vuetify.breakpoint.smAndDown) { 
        this.snackbarText = 'Bounced Email Alert - See above'
        this.snackbarColor = 'error'
        this.snackbarTimeout = 6000
        this.snackbar = true
      }
      this.emailErrorTotal = this.emailErrorArray.length
      if (this.emailErrorArray.length === 0) {
        this.showErrorDialog = false;
      }
    },
    scheduleError() {
      if (this.scheduleError === true) {
        this.snackbarText = "Another user has made changes to a route you're working on. <br> Your work orders have been de-selected.<br>Our apologies for any inconvienience this may have caused."
        this.snackbarColor = 'error'
        this.snackbarTimeout = -1
        this.snackbar = true
      }
    },
    newVersionAlert() {
      if (this.newVersionAlert) {
        if (!this.showNewVersionDialog) {
          this.showNewVersionDialog = true
        }
      }
    }
  },
  computed: {
    navColor (){
      if(debug || local){
        return "accent";
      }
      return "primary";
    },
    scheduleError () {
      return this.$store.state.schedule.scheduleError;
    },
    mainMenuTitle () {
      return this.$store.state.nav.mainMenuTitle ? this.$store.state.nav.mainMenuTitle : '';
    },
    mainMenu () {
      return this.$store.state.nav.mainMenu ? this.$store.state.nav.mainMenu : '';
    },
    subnavTitle () {
      return this.$store.state.nav.subnavTitle ? this.$store.state.nav.subnavTitle : '';
    },
    subnav () {
      return this.$store.state.nav.subnav ? this.$store.state.nav.subnav : '';
    },
    extraNavTitle () {
      return this.$store.state.nav.extraNavTitle ? this.$store.state.nav.extraNavTitle : '';
    },
    extraNav () {
      return this.$store.state.nav.extraNav ? this.$store.state.nav.extraNav : '';
    },
    profile () {
      return this.$store.state.auth.profile;
    },
    isLocal () {
      return local;
    },
    userApps () {
      return this.$store.getters.getUserApps;
    },
    isStaging () {
      return debug;
    },
    isDev () {
      return debug || local;
    },
    appName () {
      return _.toUpper(this.app);
    },
    userMenu () {
      return this.$store.getters.getSubnav;
    },
    showDrawer: {
      get () {
        return this.$store.getters.getDrawerStatus;
      },
      set (val) {
        this.$store.dispatch('setDrawer', val);
      }
    },
    newVersionAlert () {
      if ( _.has(this.$store.state.socket.message, 'message.new_version') ) {
        return this.$store.state.socket.message.message.new_version
      } else { return false }
    },
    emailErrorArray () {
      if ( _.has(this.$store.state.socket.message, 'message.bounced_emails') && this.$store.state.socket.message.message.bounced_emails.length > 0) {
        return this.$store.state.socket.message.message.bounced_emails
      } else { return [] }
    },
    taskBadge () {
      if (this.newTasks.length > 0) {
        return {
          color: 'error',
          content: this.newTasks.length
        }
      } else if (this.tasksArray.length > 0) {
        return {
          color: 'grey',
          content: this.tasksArray.length
        }
      }
      return null
    },
    tasksArray () {
      if ( _.has(this.$store.state.socket.message, 'message.tasks') && this.$store.state.socket.message.message.tasks.length > 0) {
        return this.$store.state.socket.message.message.tasks
        // completed tasks are not returned
      } else { return [] }
    },
    newTasks () {
      return this.tasksArray.filter(t => t.read == false)
    },
    showInquiryButtons () {
      return permsService.hasAccess('inquiries')

    }
  },
  mounted() {
    this.emailErrorTotal = this.emailErrorArray.length
    this.setupSockets()
  },
  methods: {
    showAPIURL () {
      alert(axios.defaults.baseURL)
    },
    openQuickNav (a) {
      window.location.href = a.app_obj.url + '?t=' + this.$store.getters.getToken
    },
    openDashboard () {
      this.$store.dispatch('clearMainMenu')
    },
    openBugTracker () {
      window.location.href = 'https://westcapsolutions.atlassian.net/servicedesk/customer/portal/'
    },
    closeScheduleError () {
      this.snackbar = false
      this.$store.dispatch('deselectScheduleError')
    },
    clearAlert(alert) {
      let index = _.findIndex(this.$store.state.socket.message.message.bounced_emails, alert)
      this.$store.state.socket.message.message.bounced_emails.splice(index, 1)
    },
    setupSockets () {
      if (this.$vuetify.breakpoint.mdAndUp) {
        console.log('Connecting to bounced email alerts');
        console.log(axios.defaults.baseURL);
        let ws = getSocketAddress();

        console.log(ws);
        let tok = store.state.auth.token
        if (tok) {
          ws += '?token=' + tok
        } else {
          tok = localStorage.getItem('token')
          ws += '?token=' + tok
        }
        console.log('connecting in MainNav')
        setTimeout(() => {
          const vm = new Vue()
          vm.$connect()
        }, 200)

        Vue.use(VueNativeSock, ws, {
          store,
          reconnection: true,
          reconnectionDelay: 3000,
          connectManually: true
        })
      }
    }
  },
  components: {
    'wc-app-menu': WCAppMenu,
    'wc-user-menu': WCUserMenu,
    'new-inquiry': NewInquiry,
    'wc-bounced-email-menu-item': WCBouncedEmailMenu
  }
}
</script>
